import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="count-up"
//
// The element's text is the finished figure ("41,404", "$407,730", "12.3%"); the
// count runs once from zero up to it. No JavaScript, reduced motion and a Turbo
// cache restore all read the finished figure.
export default class extends Controller {
  static values = { duration: { type: Number, default: 1200 } }

  connect() {
    this.finished = this.element.textContent
    // Only a figure this controller wrote is snapped to the finished one: a morph may have
    // already given the element new text before disconnect runs.
    this.finish = () => {
      cancelAnimationFrame(this.frame)
      if (this.element.textContent === this.written) this.element.textContent = this.finished
    }
    document.addEventListener("turbo:before-cache", this.finish)

    if (this.element.dataset.counted || window.matchMedia("(prefers-reduced-motion: reduce)").matches) return
    this.element.dataset.counted = "true"

    // A figure with no digits ("--") has nothing to count.
    const match = this.finished.match(/^(\D*)([\d,]+(?:\.\d+)?)(.*)$/)
    if (!match) return
    const [, prefix, figure, suffix] = match
    const decimals = (figure.split(".")[1] || "").length
    const total = Number(figure.replace(/,/g, ""))
    const startedAt = performance.now()
    const step = (now) => {
      const progress = Math.min((now - startedAt) / this.durationValue, 1)
      const eased = 1 - (1 - progress) ** 3
      const counted = (total * eased).toLocaleString("en-US", {minimumFractionDigits: decimals, maximumFractionDigits: decimals})
      this.written = progress < 1 ? prefix + counted + suffix : this.finished
      this.element.textContent = this.written
      if (progress < 1) this.frame = requestAnimationFrame(step)
    }
    this.frame = requestAnimationFrame(step)
  }

  disconnect() {
    document.removeEventListener("turbo:before-cache", this.finish)
    this.finish()
  }
}
